<script setup lang="ts">
import type { DropdownMenuItemProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { reactiveOmit } from '@vueuse/core'
import { cn } from '~ds/lib/utils'
import { DropdownMenuItem, useForwardProps } from 'reka-ui'

import { dropdownMenuItemVariants } from '.'

const props = withDefaults(defineProps<DropdownMenuItemProps & {
  class?: HTMLAttributes['class'];
  inset?: boolean;
  variant?: 'default' | 'destructive';
}>(), {
  variant: 'default',
})

const delegatedProps = reactiveOmit(props, 'inset', 'variant', 'class')

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DropdownMenuItem
    data-slot="dropdown-menu-item"
    :data-inset="inset ? '' : undefined"
    :data-variant="variant"
    v-bind="forwardedProps"
    :class="cn(dropdownMenuItemVariants({ variant }), props.class)"
  >
    <slot />
  </DropdownMenuItem>
</template>
